import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/fleetDrivers';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { goalId } = action?.payload || {};
    const response = yield call(
      axios.get,
      `${config.API_URL}/goals/${goalId}/fleet/drivers`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response?.data?.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
